import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import I18n from '../../lib/I18n';
import ErrorIcon from '../../molecules/Icon/ErrorIcon';
import './index.less';
import { fetchAndCacheRenewalReminderCardStatus } from '../../lib/RenewalReminder';

function RenewalReminderCard ({ style }) {
  const [showCard, setShowCard] = useState(false);

  useEffect(() => {
    fetchAndCacheRenewalReminderCardStatus()
      .then((status) => setShowCard(status.showRenewalReminder))
      .catch(() => setShowCard(false));
  }, []);

  if (!showCard) return null;

  return (
    <div className="renewal-card-container">
      <div className="renewal-card" style={style}>
        <div className="error-icon">
          <ErrorIcon color={'#c71514'} size={44} />
        </div>
        <div className="error-message">
          <h3 className="title">{I18n.t('RENEWAL_INFO_TITLE')}</h3>
          <p className="content">{I18n.t('RENEWAL_INFO_DESCRITPTION')}</p>
        </div>
      </div>
    </div>
  );
}

export default RenewalReminderCard;
